import React, { useState } from "react";
import "./qualification.css";

const Qualification = () => {
  const [toggleState, setToggleState] = useState(1);

  const toggleTab = (index) => {
    setToggleState(index);
  };

  return (
    <section className="qualification section">
      <h2 className="section__title">Qualification</h2>
      <span className="section__subtitle">My personel journey</span>

      <div className="qualification__container container">
        <div className="qualification__tabs">
          <div
            className={
              toggleState === 1
                ? "qualification__button qualification-active button--flex"
                : "qualification__button button--flex"
            }
            onClick={() => toggleTab(1)}
          >
            <i className="uil uil-graduation-cap qualification__icon"></i>{" "}
            Education
          </div>

          <div
            className={
              toggleState === 2
                ? "qualification__button qualification-active button--flex"
                : "qualification__button button--flex"
            }
            onClick={() => toggleTab(2)}
          >
            <i className="uil uil-briefcase qualification__icon"></i> Experience
          </div>
        </div>

        <div className="qualification__sections">
          <div
            className={
              toggleState === 1
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >
            {/* Education 1 - Right */}
            {/* <div className="qualification__data">
              <div></div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

              <div>
                <h3 className="qualification__title">MSc in Artificial Intelligence</h3>
                <span className="qualification__subtitle">
                  University of Bristol (UK)
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> 2026/2027 (Conditional Offer)
                </div>
              </div>
            </div> */}

            {/* Education 2 - Left */}
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">BSc (Hons) in Software Engineering</h3>
                <span className="qualification__subtitle">Birmingham City University (UK)</span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> 2024 - 2025 (Upper Second-Class Honours)
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>

            {/* Education 3 - Right */}
            <div className="qualification__data">
              <div></div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

              <div>
                <h3 className="qualification__title">Professional Higher Diploma in SE</h3>
                <span className="qualification__subtitle">UK Awards - Level 5</span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> 2024
                </div>
              </div>
            </div>
            
            {/* Education 4 - Left */}
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Professional Diploma in SE</h3>
                <span className="qualification__subtitle">UK Awards - Level 4</span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> 2023
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
          </div>

          <div
            className={
              toggleState === 2
                ? "qualification__content qualification__content-active"
                : "qualification__content"
            }
          >
            {/* Experience 1 - Right */}
            <div className="qualification__data">
              <div></div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

              <div>
                <h3 className="qualification__title">Full-Stack Developer (Intern)</h3>
                <span className="qualification__subtitle">
                  DartCodes (PVT) LTD (Remote)
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> Feb 2026 - Present
                </div>
              </div>
            </div>

            {/* Experience 2 - Left */}
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Technical Support Engineer</h3>
                <span className="qualification__subtitle">
                  C-Lento (PVT) LTD
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> Feb 2026 - May 2026
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>

            {/* Experience 3 - Right */}
            <div className="qualification__data">
              <div></div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>

              <div>
                <h3 className="qualification__title">Freelance Software Engineer</h3>
                <span className="qualification__subtitle">
                  Self-Employed (Remote)
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> Jan 2023 - Present
                </div>
              </div>
            </div>

            {/* Experience 4 - Left */}
            <div className="qualification__data">
              <div>
                <h3 className="qualification__title">Social Media Consultant</h3>
                <span className="qualification__subtitle">
                  Freelance
                </span>
                <div className="qualification__calender">
                  <i className="uil uil-calendar-alt"></i> Jan 2023 - Present
                </div>
              </div>

              <div>
                <span className="qualification__rounder"></span>
                <span className="qualification__line"></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Qualification;
